import { useState } from 'react'
import ReactDOM from 'react-dom/client'

import SitePlan from './inc/floorplans/sitePlan.jsx'
import Floorplans from './inc/floorplans/floorplans.jsx'

function App() {
  const units = floorplanData.units || []
  const floorplans = floorplanData.plans

  const getOptionValue = option => {
    if (typeof option === 'object' && option !== null) {
      return option.value
    }

    return option
  }

  const associatedPlanIds = new Set(units.map(unit => unit.unit_plan))
  const preferredPlanTypeOrder = ['3br', '3br_flex', '4br', '4br_rec']

  const planTypeOptions = Array.from(
    new Map(
      floorplans
        .filter(plan => associatedPlanIds.has(plan.id))
        .map(plan => plan.plan_type)
        .filter(Boolean)
        .map(option => {
          if (typeof option === 'object' && option !== null) {
            return [option.value ?? JSON.stringify(option), option]
          }

          return [option, option]
        })
    ).values()
  ).sort((a, b) => {
    const aValue = getOptionValue(a)
    const bValue = getOptionValue(b)
    const aIndex = preferredPlanTypeOrder.indexOf(aValue)
    const bIndex = preferredPlanTypeOrder.indexOf(bValue)

    if (aIndex === -1 && bIndex === -1) {
      return String(aValue).localeCompare(String(bValue))
    }

    if (aIndex === -1) {
      return 1
    }

    if (bIndex === -1) {
      return -1
    }

    return aIndex - bIndex
  })

  const firstPlan = [...floorplans].sort((a, b) => String(a.title).localeCompare(String(b.title)))[0] ?? null

  const [floorplanState, setFloorplanState] = useState({
    currentPlan: firstPlan,
    currentFilterOption: null,
    sitePlanZoomActive: false
  })

  const updateFloorplanState = updates => {
    setFloorplanState(previousState => ({
      ...previousState,
      ...updates
    }))
  }

  return (
    <>
      <SitePlan
        floorplanState={floorplanState}
        setFloorplanState={updateFloorplanState}
        planTypeOptions={planTypeOptions}
      />
      <Floorplans
        floorplanState={floorplanState}
        setFloorplanState={updateFloorplanState}
        planTypeOptions={planTypeOptions}
      />
    </>
  )
}

const root = ReactDOM.createRoot(document.getElementById('floorplansAppRoot'))
root.render(<App />)